import { render } from "./api_list.vue?vue&type=template&id=745d7af6"
import script from "./api_list.vue?vue&type=script&lang=js"
export * from "./api_list.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__